import React from "react";
import Layout from "../components/common/Layout";

const AboutUs = () => {
    return (

        <Layout>


            <section className="relative min-h-screen text-white overflow-hidden">

                {/* 🔹 Contenido principal */}
                <div className="relative z-10 flex items-center justify-center min-h-screen px-6 py-20 backdrop-blur-md">
                    <div className="bg-white/90 dark:bg-[#112626]/90 rounded-xl shadow-xl p-10 max-w-4xl text-gray-800 dark:text-gray-100 text-justify">
                        <h2 className="text-5xl font-bold mb-6 text-primary text-center dark:text-secondary">
                            {["Work.", "Travel.", "Connect.", "Repeat."].map((word, index) => (
                                <span
                                    key={index}
                                    className="inline-block opacity-0 animate-fade-in-up"
                                    style={{ animationDelay: `${index * 0.8}s`, animationFillMode: "forwards" }}
                                >
                                    {word}&nbsp;
                                </span>
                            ))}
                        </h2>
                        <p className="text-lg mb-10 italic text-gray-600 text-center dark:text-lightGreen">
                            At Slowork, we’re not just building a platform — we’re leading a movement.
                        </p>

                        <p className="text-lg mb-6">
                            We believe remote work shouldn’t mean isolation or rushed travel. It should be about
                            <span className="font-semibold"> meaningful connections</span>,
                            <span className="font-semibold"> inspiring places</span>, and a lifestyle that
                            balances <span className="font-semibold">work, adventure, and sustainability 🍃</span>
                        </p>

                        <p className="text-lg mb-6">
                            That’s why we’ve built a <span className="font-semibold">global network</span> of handpicked accommodations, vibrant communities, and supportive ecosystems — designed for
                            remote workers, entrepreneurs, and creatives who crave more than just a place to stay.
                        </p>

                        <p className="text-lg mb-6">
                            At Slowork, you don’t just find a desk — you find a <span className="font-semibold">community</span>. You don’t just visit a destination — you become part of a
                            <span className="font-semibold"> sustainable movement</span> that honors local cultures and environments.
                        </p>

                        <p className="text-lg mb-3">
                            Whether you’re a solo traveler, a family searching for stability, or a team on a remote retreat, Slowork connects you to spaces that reflect your
                            <span className="font-semibold"> values, goals, and lifestyle</span>.
                        </p>

                        <p className="text-xl font-medium mt-7 mb-12 text-center">
                            Your work should fuel your freedom — not limit it.
                        </p>
                        <p className="text-3xl font-semibold mb-6 text-primary dark:text-lightGreen text-center">
                            Welcome to the <span className="text-[#E0BB44] font-extrabold ">future</span> of remote work
                        </p>
                        <p className="text-lg text-gray-500 mt-2 italic text-center dark:text-lightGreen">
                            "Built by those who dare to do things differently"
                        </p>
                    </div>
                </div>
            </section>

        </Layout>
    );
};

export default AboutUs;
